import React from 'react';

import { hotelRoomBlocksPageData } from '@data-ts/pages/hotel-room-blocks';
import { CloudImage } from '@components/CloudImage';
import { Columns } from '@components/Columns';
import {
  StyledSectionWrapper,
  StyledBox,
  BlogCenterTextPairing,
  StyledButtonBox,
  StyledButton,
  StyledColumnDesktop,
  DisplayOnMobile,
  ImageDesktop,
  WrapperSection,
  ColumnInfo,
} from './PremiumPerksUpgradesSection.styles';

const premiumPerksUpgradesSectionData = hotelRoomBlocksPageData.premiumPerksUpgradesSection;

export const PremiumPerksUpgradesSection: React.FC = () => {
  return (
    <StyledSectionWrapper as="section" id="Premium_Perks_Upgrades" marginTop={[0, 12]}>
      <WrapperSection verticalAlign="center" marginTop={[8, 0]}>
        <StyledColumnDesktop width={6} mobile={12}>
          <ImageDesktop
            style={{ borderRadius: 12, display: 'block', transform: 'rotate(-1.71deg)' }}
            src="hotel-room-blocks/PremiumPerksUpgrades/Premium-Percs-Desktop-1.jpeg"
            width={'100%'}
          />
        </StyledColumnDesktop>
        <ColumnInfo width={6} mobile={12}>
          <StyledBox>
            <BlogCenterTextPairing
              alignment="left"
              eyebrow={premiumPerksUpgradesSectionData.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={premiumPerksUpgradesSectionData.title}
              titleVariant="hed56"
              titleColor="neutra6"
              titleTagName="h2"
              body={premiumPerksUpgradesSectionData.description}
              bodyVariant="dek24"
              bodyColor="neutra5"
              bodyTagName="p"
            />
            <StyledButtonBox marginTop={[8, 8]} marginBottom={[10, 0]}>
              <StyledButton id="premiumPerksUpgradesSectionGetStartedBtn" variant="primary" page={'hotel-room-blocks'}>
                {premiumPerksUpgradesSectionData.buttonStarted}
              </StyledButton>
            </StyledButtonBox>
          </StyledBox>
        </ColumnInfo>
        <DisplayOnMobile>
          <CloudImage
            src="hotel-room-blocks/PremiumPerksUpgrades/Premium-Percs-Mobile.png"
            optimization="none"
            style={{
              borderRadius: `0px 12px 12px 0px`,
              flex: 1,
              width: '100%',
              objectFit: 'fill',
            }}
          />
        </DisplayOnMobile>
      </WrapperSection>
    </StyledSectionWrapper>
  );
};
